import * as React from "react";
const SvgFiRrBroadcastTower = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-broadcast-tower_svg__a)">
      <path
        fill="#062147"
        d="M12 5.5c-1.93 0-3.5 1.57-3.5 3.5a3.51 3.51 0 0 0 2.5 3.354V23a1 1 0 0 0 2 0V12.354A3.51 3.51 0 0 0 15.5 9c0-1.93-1.57-3.5-3.5-3.5m0 5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5M7.757 4.833A5.96 5.96 0 0 0 6 9.076c0 1.603.624 3.109 1.757 4.243a.999.999 0 1 1-1.414 1.414A7.95 7.95 0 0 1 4 9.076c0-2.137.832-4.146 2.343-5.657a.999.999 0 1 1 1.414 1.414M20 9.076a7.95 7.95 0 0 1-2.343 5.657.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414A5.96 5.96 0 0 0 18 9.076a5.96 5.96 0 0 0-1.757-4.243.999.999 0 1 1 1.414-1.414A7.95 7.95 0 0 1 20 9.076M4.929 16.147a.999.999 0 1 1-1.414 1.414c-4.679-4.679-4.679-12.292 0-16.971a.999.999 0 1 1 1.414 1.414c-3.898 3.899-3.898 10.244 0 14.143m15.557 1.414a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414c3.898-3.899 3.898-10.243 0-14.142A.999.999 0 1 1 20.486.591c4.679 4.678 4.679 12.292 0 16.97"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-broadcast-tower_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBroadcastTower;
